import { defineMessages } from "react-intl";
import { renderChip } from "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "react";
import "@mui/material";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "@mui/x-data-grid";
import "uuid";
import "../../../components/alerts/InfoMessage.js";
import "../../../components/alerts/NoAccessInfoMessage.js";
import "../../../components/alerts/Message.style.js";
import "../../../components/alerts/InfoAlert.js";
import "../../../components/alerts/InfoMessageHoc.js";
import "../../../components/checkbox/StyledCheckbox.js";
import "fast-deep-equal/es6";
import "../../../components/pagination/StyledPagination.js";
import "../../../components/data-grid/mui/GridColumnsButton.js";
import "../../../components/data-grid/mui/GridColumnsPanel.js";
import "../../../components/data-grid/mui/hooks/useGridCellStyle.js";
import "../../../components/data-grid/mui/hooks/useGridLocalization.js";
import "fast-deep-equal";
import "../../../components/data-grid/mui/hooks/useGridStyle.js";
import "immer";
import "../../../components/data-grid/mui/cells/InvalidDataCell.js";
import { withDataGridEntityServer, withDataGridEntityClient } from "../../../components/data-grid/mui/DataGridEntity.js";
import { MuiDataGridClient } from "../../../components/data-grid/mui/MuiDataGridClient.js";
import { MuiDataGridServer } from "../../../components/data-grid/mui/MuiDataGridServer.js";
import { DataGridEntityConfigFactory } from "../../../components/data-grid/mui/types.js";
import "../../../components/data-grid/mui/cells/CurrencyCell.js";
import "../../../components/data-grid/mui/cells/DateCell.js";
import { renderCellWithTooltip } from "../../../components/data-grid/mui/cells/GridCellWithTooltip.js";
import "../../../components/data-grid/mui/cells/LabelsCell.js";
import "../../../components/data-grid/mui/cells/NumberCell.js";
import { renderCellHeader } from "../../../components/data-grid/mui/cells/TextCell.js";
import "../../../components/link/LinkHOC.js";
import "../../../components/link/LinkButton.js";
import "../../../components/data-grid/mui/cells/ActionWithConfirmationButton.js";
import "../../../components/data-grid/mui/cells/TextListWithTooltipCell.js";
import "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import "../../../components/data-grid/mui/cells/DurationCell.js";
import "../../../components/data-grid/mui/cells/PercentCell.js";
import "../../../components/modal/BulkModalContent.js";
import "../../../components/modal/BulkModalProvider.js";
import "../../../components/modal/ModalButtons.js";
import "../../../components/modal/Modal.style.js";
import "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import "../../../components/error/ErrorAccordion.js";
import "../../../components/error/ErrorDetails.js";
import "../../../components/error/localize.js";
import "../../../components/error/ErrorModal.js";
import "../../../components/error/GlobalServerErrorMessage.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "../../../components/modal/types.js";
import "../../../components/modal/ActionConfirmationModal.js";
import "../../../components/data-grid/mui/cells/ButtonCell.js";
import { PlayerBonusStatusTypeName } from "../constants.js";
import { renderPlayerBonusAmount } from "./AmountCell.js";
const localizedHeaders = defineMessages({
  playerBonusGridBonusStatus: {
    id: "PlayerBonusGridHeader_bonusStatus",
    defaultMessage: "Bonus Status"
  },
  playerBonusGridBonusCode: {
    id: "PlayerBonusGridHeader_bonusCode",
    defaultMessage: "Bonus Code"
  },
  playerBonusGridBonusName: {
    id: "PlayerBonusGridHeader_bonusName",
    defaultMessage: "Bonus Name"
  },
  playerBonusGridDescription: {
    id: "PlayerBonusGridHeader_description",
    defaultMessage: "Description"
  },
  playerBonusGridAmountAvailable: {
    id: "PlayerBonusGridHeader_amountAvailable",
    defaultMessage: "Amount Available"
  },
  playerBonusGridAmountRedeemed: {
    id: "PlayerBonusGridHeader_amountRedeemed",
    defaultMessage: "Amount Redeemed"
  },
  playerBonusGridRemainingAmount: {
    id: "PlayerBonusGridHeader_remainingAmount",
    defaultMessage: "Remaining Amount"
  },
  playerBonusGridExpiryDate: {
    id: "PlayerBonusGridHeader_expiryDate",
    defaultMessage: "Expiry date"
  },
  playerBonusGridEmptyList: {
    id: "PlayerBonusGridHeader_emptyList",
    defaultMessage: "Bonus codes list is empty"
  },
  playerBonusGridTitle: {
    id: "PlayerBonusGridHeader_title",
    defaultMessage: "Cash Bonuses"
  }
});
class DataGridPlayerBonusConfigFactory extends DataGridEntityConfigFactory {
  getColumnConfig() {
    const columnsMapping = {
      "created_at.seconds": {
        field: "created_at.seconds",
        valueGetter: (_, row) => this.getCreatedAt(row),
        sortable: true,
        hide: true
      },
      bonus_status: {
        field: "bonus_status",
        valueGetter: (_, row) => this.getBonusStatus(row),
        renderHeader: () => renderCellHeader(localizedHeaders.playerBonusGridBonusStatus),
        renderCell: (params) => renderChip(params.value, PlayerBonusStatusTypeName),
        sortable: false,
        flex: 1
      },
      marketing_code: {
        field: "marketing_code",
        valueGetter: (_, row) => this.getMarketingCode(row),
        renderHeader: () => renderCellHeader(localizedHeaders.playerBonusGridBonusCode),
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 1
      },
      bonus_name: {
        field: "bonus_name",
        valueGetter: (_, row) => this.getBonusName(row),
        renderHeader: () => renderCellHeader(localizedHeaders.playerBonusGridBonusName),
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 1
      },
      desc: {
        field: "desc",
        valueGetter: (_, row) => this.getDesc(row),
        renderHeader: () => renderCellHeader(localizedHeaders.playerBonusGridDescription),
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 1
      },
      realized_amount: {
        field: "realized_amount",
        valueGetter: (_, row) => this.getRealizedAmount(row),
        renderHeader: () => renderCellHeader(localizedHeaders.playerBonusGridAmountRedeemed),
        renderCell: renderPlayerBonusAmount,
        sortable: false,
        flex: 1
      },
      total_amount: {
        field: "total_amount",
        valueGetter: (_, row) => this.getTotalAmount(row),
        renderHeader: () => renderCellHeader(localizedHeaders.playerBonusGridAmountAvailable),
        renderCell: renderPlayerBonusAmount,
        sortable: false,
        flex: 1
      },
      remaining_amount: {
        field: "remaining_amount",
        valueGetter: (_, row) => this.getRemainingAmount(row),
        renderHeader: () => renderCellHeader(localizedHeaders.playerBonusGridRemainingAmount),
        renderCell: renderPlayerBonusAmount,
        sortable: false,
        flex: 1
      },
      "expire_at.seconds": {
        field: "expire_at.seconds",
        valueGetter: (_, row) => this.getExpireAt(row),
        renderHeader: () => renderCellHeader(localizedHeaders.playerBonusGridExpiryDate),
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 1
      }
    };
    return columnsMapping;
  }
  getCreatedAt(model) {
    return model?.created_at;
  }
  getBonusStatus(model) {
    return model?.bonus_status;
  }
  getMarketingCode(model) {
    return model?.marketing_code;
  }
  getBonusName(model) {
    return model?.bonus_name;
  }
  getDesc(model) {
    return model?.desc;
  }
  getRealizedAmount(model) {
    return { amount: model?.realized_amount, bonusDescription: model?.desc };
  }
  getTotalAmount(model) {
    return { amount: model?.total_amount, bonusDescription: model?.desc };
  }
  getRemainingAmount(model) {
    return { amount: model?.remaining_amount, bonusDescription: model?.desc };
  }
  getExpireAt(model) {
    return model?.expire_at;
  }
}
const DataGridPlayerBonusClient = withDataGridEntityClient(
  MuiDataGridClient,
  () => new DataGridPlayerBonusConfigFactory().getColumnConfig()
);
const DataGridPlayerBonusServer = withDataGridEntityServer(
  MuiDataGridServer,
  () => new DataGridPlayerBonusConfigFactory().getColumnConfig()
);
export {
  DataGridPlayerBonusClient,
  DataGridPlayerBonusConfigFactory,
  DataGridPlayerBonusServer
};
//# sourceMappingURL=DataGrid.js.map
